/* __next_internal_client_entry_do_not_use__ useLoggedOutProductFilters auto */ import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { ALL_PRODUCTS_KEY, CATEGORY_KEY_PREFIX } from "@faire/retailer-visitor-shared/components/LoggedOutBrand/consts";
import { Path } from "@faire/web--source/common/Path";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
var DEFAULT_CATEGORY_FILTER_KEY = "".concat(CATEGORY_KEY_PREFIX).concat(ALL_PRODUCTS_KEY);
export var useLoggedOutProductFilters = function(locationPush) {
    var location = useZustandLocation(function(param) {
        var search = param.search, pathname = param.pathname;
        return {
            search: search,
            pathname: pathname
        };
    });
    var filters = parseQueryParams(location.search).get("filters");
    // Logged-out page currently only supports filtering by a single C2.
    var selectedCategoryFilterKey = filters === null || filters === void 0 ? void 0 : filters.split(",").find(function(filter) {
        return filter.startsWith(CATEGORY_KEY_PREFIX);
    });
    var activeTab = selectedCategoryFilterKey !== null && selectedCategoryFilterKey !== void 0 ? selectedCategoryFilterKey : DEFAULT_CATEGORY_FILTER_KEY;
    var setCategoryFilterKey = function(categoryFilterKey) {
        var path = getPathWithCategoryFilterKey(location, categoryFilterKey);
        locationPush({
            pathname: path.pathname,
            search: path.searchParams.toString()
        });
    };
    return {
        selectedCategoryFilterKey: selectedCategoryFilterKey,
        activeTab: activeTab,
        setCategoryFilterKey: setCategoryFilterKey
    };
};
var getPathWithCategoryFilterKey = function(location, categoryFilterKey) {
    var path = new Path(location);
    if (categoryFilterKey === DEFAULT_CATEGORY_FILTER_KEY) {
        path.delete("filters");
    } else {
        path.replace({
            filters: categoryFilterKey
        });
    }
    return path;
};
